const NAMESPACE = "sensitiveData";

const KEYS = {
    hideButtonLabel: "hideButtonLabel",
    showButtonLabel: "showButtonLabel",
    editButtonLabel: "editButtonLabel",
    editHeader: "editHeader",
    cancelButtonLabel: "cancelButtonLabel",
    okButtonLabel: "okButtonLabel",
    viewSensitiveDataAlertTitle: "viewSensitiveDataAlertTitle",
    viewSensitiveDataAlertMessage: "viewSensitiveDataAlertMessage"
};

const MESSAGES = {
    [KEYS.hideButtonLabel]: {
        value: "Hide",
        comment: "Label for button to hide sensitive data."
    },
    [KEYS.showButtonLabel]: {
        value: "Show",
        comment: "Label for button to show sensitive data."
    },
    [KEYS.editButtonLabel]: {
        value: "Edit",
        comment: "Label for button to edit previously submitted sensitive data."
    },
    [KEYS.editHeader]: {
        value: "Edit Sensitive Data",
        comment: "Header for edit sensitive data dialog."
    },
    [KEYS.cancelButtonLabel]: {
        value: "Cancel",
        comment: "Button to cancel editing of submitted data."
    },
    [KEYS.okButtonLabel]: {
        value: "OK",
        comment: "Button to submit edited submitted data."
    },
    [KEYS.viewSensitiveDataAlertTitle]: {
        value: "View Sensitive Data",
        comment: "Header for dialog when asking to view sensitive data."
    },
    [KEYS.viewSensitiveDataAlertMessage]: {
        value: "Are you sure you want to reveal this sensitive data?",
        comment: "Message for dialog when user asks to view sensitive data"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
